import { i as e, r as t } from "./newsletter.service-b1LnfKOo.js";
import { t as n } from "./_plugin-vue_export-helper-B52Kst-M.js";
import { computed as r, createBlock as i, createElementBlock as a, createVNode as o, defineAsyncComponent as s, defineComponent as c, mergeModels as l, normalizeClass as u, onBeforeMount as d, openBlock as f, ref as p, unref as m, useModel as h, withCtx as g } from "vue";
import { CardItem as _, quasarValidateRules as v } from "@editor/ui-utils";
import { QBtn as y, QDialog as b, useFormChild as x } from "quasar";
import { useI18n as S } from "vue-i18n";
//#endregion
//#region src/selectors/newsletter-list.selector.vue
var C = /* @__PURE__ */ n(/* @__PURE__ */ c({
	__name: "newsletter-list.selector",
	props: /* @__PURE__ */ l({
		rules: { default: void 0 },
		brand: { default: void 0 },
		disable: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(n) {
		let c = s(() => import("./newsletter-edit.view-DBarwuMT.js")), l = s(() => import("./newsletter-list.view-Dqr0PlyS.js")), C = n, w = h(n, "modelValue"), { t: T } = S(), E = p(!1), D = p(!1), O = p(!0), k = p(t()), A = p(""), j = p(), M = () => {
			C.disable || (D.value = !0);
		}, N = r(() => {
			let e = k.value.recipientGroup ? `${k.value.recipientGroup.groupId} - ${k.value.recipientGroup.name}` : "";
			return {
				_id: k.value._id || "",
				title: e,
				kicker: k.value.title || ""
			};
		}), P = () => {
			let e = v(k.value, C.rules);
			O.value = !e, A.value = e;
		};
		x({
			validate() {
				return P(), O.value || j.value?.scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "center"
				}), O.value;
			},
			resetValidation() {
				O.value = !0;
			}
		});
		let F = (e) => {
			k.value = e, D.value = !1, w.value = e._id, P();
		}, I = () => {
			D.value = !1, E.value = !1;
		}, L = () => {
			k.value = t(), w.value = void 0, I();
		}, R = () => {
			E.value = !0;
		}, z = (e) => {
			e && (E.value = !1, D.value = !1, k.value = e, w.value = e._id, P());
		};
		return d(async () => {
			w.value && (k.value = await e(w.value));
		}), (e, t) => (f(), a("div", {
			ref_key: "wrapper",
			ref: j
		}, [w.value ? (f(), i(m(_), {
			key: 0,
			disable: n.disable,
			"is-clickable": !n.disable,
			class: u({ invalid: !O.value }),
			item: N.value,
			onRemoveItem: L,
			onClick: M
		}, null, 8, [
			"disable",
			"is-clickable",
			"class",
			"item"
		])) : (f(), i(m(y), {
			key: 1,
			class: u(["newsletter-selector-button", {
				invalid: !O.value,
				"newsletter-selector-button": !0
			}]),
			label: m(T)("newsletter.selectNewsletterWidget"),
			outline: "",
			color: "primary",
			"icon-right": "open_in_new",
			"data-qa-newsletter-selector-button": "",
			disable: n.disable,
			onClick: M
		}, null, 8, [
			"class",
			"label",
			"disable"
		])), o(m(b), {
			modelValue: D.value,
			"onUpdate:modelValue": t[0] ||= (e) => D.value = e,
			container: "",
			"data-qa-edit-newsletter-dialog": "",
			"full-height": "",
			"full-width": "",
			"allow-focus-outside": "",
			onHide: I
		}, {
			default: g(() => [!w.value && !E.value ? (f(), i(m(l), {
				key: 0,
				brand: n.brand,
				"disable-brand": "",
				dialog: !0,
				onClose: I,
				"onClick:newsletter": F,
				"onClick:newsletter:new": R
			}, null, 8, ["brand"])) : w.value ? (f(), i(m(c), {
				key: 2,
				id: w.value,
				"allowed-brand": n.brand,
				dialog: !0,
				title: m(T)("newsletterEdit.editNewsletter"),
				"back-route": void 0,
				onClose: I,
				"onBack:modal": I,
				"onClick:newsletter:save": z
			}, null, 8, [
				"id",
				"allowed-brand",
				"title"
			])) : (f(), i(m(c), {
				key: 1,
				"allowed-brand": n.brand,
				"back-route": void 0,
				dialog: !0,
				title: m(T)("newsletterList.createNewsletter"),
				onClose: I,
				"onBack:modal": I,
				"onClick:newsletter:save": z
			}, null, 8, ["allowed-brand", "title"]))]),
			_: 1
		}, 8, ["modelValue"])], 512));
	}
}), [["__scopeId", "data-v-ee3dfa4a"]]);
//#endregion
export { C as t };

//# sourceMappingURL=newsletter-list.selector-rioHEpT0.js.map